import { AccountCircle } from '@mui/icons-material';
import { Button, InputAdornment, Stack } from '@mui/material';
import type { FormEvent } from 'react';
import { WhiteTextField } from '../../../styles/WhiteTextFieldStyle';

interface Step1Props {
  email: string;
  error: boolean;
  onEmailChange: (value: string) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export function ResetPasswordStep1({ email, error, onEmailChange, onSubmit }: Step1Props) {
  return (
    <form onSubmit={onSubmit}>
      <Stack spacing={3}>
        <h2>パスワードの再設定</h2>
        <p>
          アカウントに登録されたメールアドレス宛に、パスワード再設定用コードを記載したメールを送信します。
        </p>

        <WhiteTextField
          label="User"
          id="email"
          name="email"
          fullWidth
          focused
          size="small"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            },
          }}
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          error={error}
          helperText={error ? 'メールアドレスを入力してください' : ''}
        />

        <Button type="submit">認証コードを送信する</Button>
      </Stack>
    </form>
  );
}
